

const initialState = {
  open: false,
  requestId: '',
  rateConversionSetting: '',
  loading: false,
  success: false,
  messageForDL: '',
  priority: 'Medium',
};


export default function requestDL(state = initialState, { type, payload }) {
  switch (type) {
    case 'OPEN_REQUEST_DL':
      return {
        ...state,
        open: true,
        contractId: payload.contractId,
        files: payload.files,
      };
    case 'CHECK_RATE_LOADING_SETTING':
      return {
        ...state,
        rateConversionSetting: payload.setting,
      };
    case 'CHECK_RATE_LOADING_PRIORITY':
      return {
        ...state,
        priority: payload.priority,
      };
    case 'ENTER_MESSAGE_FOR_DL_IN_REQUEST_DIALOG':
      return {
        ...state,
        messageForDL: payload,
      };
    case 'REQUEST_DL_STARTED':
      return {
        ...state,
        loading: true,
      };
    case 'REQUEST_DL_ERROR':
      return {
        ...state,
        loading: false,
      };
    case 'REQUEST_DL_SUCCESS':
      return {
        ...state,
        loading: false,
        success: true,
      };
    case 'CLOSE_REQUEST_RATE_LOADING_DIALOG':
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/contracting/dialogs/dialog-reducers/request-data-loading.js